var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateCohort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58 4.43c1.573 0 2.848 1.176 2.848 2.629 0 1.452-1.275 2.63-2.847 2.63-1.573 0-2.847-1.178-2.847-2.63 0-1.453 1.274-2.63 2.847-2.63zm-.005 1.13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm.006 4.55c1.894 0 3.464 1.37 3.574 3.117l.013 1.995a.735.735 0 0 1-.243.552.873.873 0 0 1-.59.226H.831a.868.868 0 0 1-.589-.226A.743.743 0 0 1 0 15.23l.004-1.974v-.013c.112-1.762 1.68-3.133 3.577-3.133zm.002 1.07c-1.249 0-2.29.91-2.37 2.09l-.003 1.66h4.75l-.012-1.703c-.093-1.15-1.125-2.047-2.365-2.047zM11.5 0a1 1 0 0 1 1 1v2.5H15a1 1 0 1 1 0 2h-2.5V8a1 1 0 1 1-2 0V5.5H8a1 1 0 1 1 0-2h2.5V1a1 1 0 0 1 1-1z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCohort);
export default __webpack_public_path__ + "static/media/create-cohort.ce04e46638601dbe5f2ac82c16b70e17.svg";
export { ForwardRef as ReactComponent };